import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

const StyledButton = styled(
  ({ backgroundColor, fontColor, size, ...otherProps }) => (
    <Button {...otherProps} size={size || 'large'} />
  ),
)`
  background-color: ${(props) => {
    if (props.variant === 'contained') return props.backgroundColor;
    else if (props.variant === 'outlined') return '#fff';
  }} !important;

  color: ${(props) => {
    if (props.fontColor) return props.fontColor;
    else if (props.variant === 'contained') return '#fff';
    else return props.backgroundColor;
  }} !important;

  border: ${(props) => {
    if (props.variant === 'outlined')
      return `1px solid ${props.backgroundColor}`;
  }} !important;

  border-radius: 8px !important;

  &:hover {
    color: ${(props) => {
      if (props.fontColor) return props.fontColor;
      else if (props.variant === 'outlined') return '#fff';
    }} !important;
    background-color: ${(props) => {
      if (props.variant === 'outlined') return props.backgroundColor;
    }} !important;
    filter: brightness(90%);
  }
  &:disabled {
    color: #8e8e8e !important;
    background-color: ${(props) => {
      if (props.variant === 'contained') return '#E4E4E4';
      else if (props.variant === 'outlined') return '#fff';
    }} !important;

    border: ${(props) => {
      if (props.variant === 'outlined') return '1px solid #C4C4C4';
    }} !important;
  }
`;

export default StyledButton;
